import React, { useMemo, useState } from 'react';
import Icon from 'components/Utils/NewIcon';
import AddDocument from 'components/HealthRecords/Documents/AddDocument';
import DefaultModal from 'components/Utils/DefaultModal';
import UnreadBadge from 'components/Common/UnreadBadge';
import TaskUtils from 'services/TaskUtils';
import { ExportCPPModal } from 'components/Patient/CPPChat/ResourcesPanel';
import { useAppSelector } from 'careand-redux/store';

export const ExportCPPIcon = ({ patient }) => {
  const [exportModal, setExportModal] = useState(false);
  return (
    <>
      <div className="icon-bubble" onClick={() => setExportModal(true)}>
        <Icon
          height="20px"
          src="file-export"
          className="secondary"
          fontAwesomeStyle="fas"
          showTooltip={true}
          tooltipPlace="left"
          alt="Export Health Records as PDF"
        />
      </div>
      {exportModal && <ExportCPPModal patient={patient} onClose={() => setExportModal(false)} />}
    </>
  );
};

export const TasksUnreadBadge = ({ patient }) => {
  const tasks = useAppSelector((state) => state.tasks.byId);
  const authentication = useAppSelector((state) => state.authentication);

  const patientTasks = tasks[patient.id];
  const ownId = authentication.decodedToken.sub;

  const unreadCount = useMemo(
    () => TaskUtils.totalUnreadBadge(patientTasks, ownId),
    [patientTasks, ownId],
  );
  return <UnreadBadge unreadCount={unreadCount} />;
};

export const AddDocumentModal = ({ onRequestClose, patient, open, initialScreen }) =>
  open && (
    <DefaultModal
      className="large-modal add-document-modal"
      key="add-document-modal"
      title="Add Document"
      content={
        <AddDocument onSave={onRequestClose} patient={patient} initialScreen={initialScreen} />
      }
      isOpen={open}
      onRequestClose={onRequestClose}
    />
  );
